module.exports = __webpack_public_path__ + "static/media/logo_cn_en.714e7b10.svg";